<div class="share-popup-bg" (click)="close()" @opacityInOut></div>
<div class="share-popup" @scaleInOut>
  <i class="app-ico-mask app-ico-mask__x" (click)="close()"></i>
  <div class="share-popup__header">
    <h2>Share</h2>
  </div>
  <div class="share-popup__list">
    <div class="is-btn is-btn__outfill" (click)="share('facebook')" shareButton="facebook" [url]="url">
      <i class="app-ico app-ico__social-facebook"></i> Facebook
    </div>
    <div class="is-btn is-btn__outfill" (click)="share('whatsapp')" shareButton="whatsapp" [url]="url">
      <i class="app-ico app-ico__social-whatsapp"></i> WhatsApp
    </div>
    <div class="is-btn is-btn__outfill" (click)="share('linkedin')" shareButton="linkedin" [url]="url">
      <i class="app-ico app-ico__social-linkedin"></i> LinkedIn
    </div>
    <div class="is-btn is-btn__outfill" (click)="share('telegram')" shareButton="telegram" [url]="url">
      <i class="app-ico app-ico__social-telegram"></i> Telegram
    </div>
    <div class="is-btn is-btn__outfill" (click)="share('twitter')" shareButton="twitter" [url]="url">
      <i class="app-ico app-ico__social-twitter"></i> Twitter
    </div>
    <div class="is-btn is-btn__outfill" (click)="share('email')" shareButton="email" [url]="url">
      <i class="app-ico-mask app-ico-mask__envelope"></i> Email
    </div>
    <div class="is-btn is-btn__outfill" 
      shareButton="copy"
      [url]="url" 
      [class.is-disabled]="copied"
      (click)="wasCopied()">
      <ng-container *ngIf="!copied">
        <i class="app-ico-mask app-ico-mask__copy"></i> Copy link
      </ng-container>
      <ng-container *ngIf="copied">
        <i class="app-ico-mask app-ico-mask__checked"></i> Copied to clipboard
      </ng-container>
    </div>
  </div>
</div>